/****************************************************
 * Module Name:  addConvertToStoneModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import { Box, Button, Typography } from "@mui/material";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";

function AddConvertToStoneModal({
    show,
    handleClose,
    handleValidation,
    handleSave,
    sourceData,
    loading,
}) {
    const [showError, setShowError] = useState(false);

    const prepareData = () => {
        let arr = []
        sourceData.map((item) => {
            let obj = {
                packetid: item.packetid,
                kapanid: item.kapanid,
            };
            arr.push(obj)
            return true
        })
        return arr
    }

    const saveHandler = () => {
        let data = prepareData()
        if (handleSave) {
            if (handleValidation) {
                if (handleValidation(data)) {
                    //need to add labId here and in the parent component if need for validation
                    handleSave(data);
                } else {
                    setShowError(true);
                }
            } else {
                handleSave(data);
            }
        }
    };

    const closeErrorDialog = () => {
        setShowError(false);
    };

    return (
        <div>
            <TabMenuSnackbar
                show={showError}
                message={
                    <Box>
                        Convert stone validation Failed
                        <br /> Please enter correct data
                    </Box>
                }
                variant={"error"}
                autoHide={false}
                handleClose={closeErrorDialog}
                title="Validation Failure"
            />
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={true}
                centered
                enforceFocus={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;Convert To Stone
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Typography variant="h6" sx={{ textAlign: "center" }}>
                        Are you sure you want to <strong>Convert</strong> this Packets ?
                    </Typography>
                </Modal.Body>
                <Modal.Footer>
                    <LoadingButton
                        variant="contained"
                        onClick={saveHandler}
                        type="Submit"
                        loading={loading}
                        loadingPosition="start"
                        startIcon={<ThumbUpAltIcon size="large" />}
                        sx={{ mr: 3 }}
                    >
                        Yes
                    </LoadingButton>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                        sx={{ mr: 2 }}
                    >
                        No
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default AddConvertToStoneModal;
